<template>
  <div class="container_box">
    <Tabs v-model="pageParams.toExamineStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in toExamineList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '100px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="labelTimerName">
              <Date-picker
                type="datetimerange"
                class="filter_time_box"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registerTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input :placeholder="placeholderName" v-model.trim="pageParams.searchValue"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset('update')" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search" :disabled="tableLoading">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="490"
        :loading="tableLoading"
        @on-sort-change="sortChange"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--入驻、工商信息变更审核弹窗-->
    <addSupplierModal ref="addSupplier" @updateData="search()"></addSupplierModal>
    <!--供应商日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SUPPLIER_LOG', 'SYSTEM_LOG']"></commonLogModal>
    <!--店铺信息变更审核弹窗-->
    <storeInfoReviewModal ref="storeInfoReview" @updateData="search()"></storeInfoReviewModal>
    <!--收款账户变更审核弹窗-->
    <collectionAccountReviewModal ref="collectionAccountReview" @updateData="search()"></collectionAccountReviewModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";
import addSupplierModal from "@/views/yms/components/supplierManagement/addSupplierModal.vue";
import storeInfoReviewModal from "@/views/yms/components/supplierManagement/storeInfoReviewModal.vue";
import collectionAccountReviewModal from "@/views/yms/components/supplierManagement/collectionAccountReviewModal.vue";
import {getEnumName, getDataSetBatchList, getEnumList} from "@/utils/common";

const DROPDOWNINPUTLIST = [
  {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002806'), parameterKey: 'ymsMerchantIds'},
  {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002807'), parameterKey: 'mobiles'},
  {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002808'), parameterKey: 'emails'}
]
export default {
  name: 'supplierAuditList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      registerTime: [],
      pageParamsStatus: false,
      pageParams: {
        supplierAuditStatus: 1, // 入驻审核状态: 0审核不通过、1待审核、2审核通过
        updateSupplierAuditStatus: null, // 工商信息变更审核状态: 0审核不通过、1待审核、2审核通过
        updateSupplierStoreAuditStatus: null, // 店铺信息变更审核状态：0审核不通过、1待审核、2审核通过
        updateSupplierPayAccountAuditStatus: null, // 收款信息变更审核状态: 0审核不通过、1待审核、2审核通过
        toExamineStatus: '1',
        createdStartTime: null, // 入驻审核的提交时间
        createdEndTime: null,
        updateSupplierAuditStartTime: null, // 供应商工商信息变更提交审核时间
        updateSupplierAuditEndTime: null,
        supplierAuditedStartTime: null, // 审核驳回时间
        supplierAuditedEndTime: null,
        updateSupplierStoreAuditStartTime: null, // 店铺信息变更提交审核时间
        updateSupplierStoreAuditEndTime: null,
        updateSupplierPayAccountAuditStartTime: null, // 收款账户变更提交审核时间
        updateSupplierPayAccountAuditEndTime: null,
        ymsMerchantIds: '', // 供应商编号
        mobiles: '', // 手机号
        emails: '', // 邮箱
        searchValue: '',
        upDown: 'up',
        orderBy: 'createdTime',
        pageNum: 1,
        pageSize: 15
      },
      // 各Tab页可见字段key列表（公共字段通过展开运算符复用）
      columnKeyGroups: (() => {
        const headerKeys = ['ymsMerchantId', 'supplierName'];
        const enterpriseKeys = ['currency', 'businessLicensePath', 'contacts', 'mobile', 'phone', 'email', 'totalSkuNumber'];
        const footerKeys = ['options'];
        const businessInfoKeys = ['businessLicensePath', 'identificationCardPath', 'businessScale', 'contactName', 'contactPhoneNumber', 'fixedTelephone', 'email'];
        const shopInfoKeys = ['shopName', 'shopLogoPath', 'managementModel', 'plannedBusinessCategory', 'shelvesProductsNumber', 'productReleaseNumber', 'businessAddress', 'address'];
        const payAccountKeys = ['originalRecord', 'changeRecord'];
        const rejectionKeys = ['supplierAuditedTime', 'reasonForRejection'];
        return {
          // 入驻审核
          '1': [...headerKeys, ...enterpriseKeys, 'createdTime', ...footerKeys],
          // 工商信息变更审核
          '2': [...headerKeys, ...businessInfoKeys, 'createdTime', ...footerKeys],
          // 工商信息变更审核驳回（与审核保持一致 + 驳回字段）
          '3': [...headerKeys, ...businessInfoKeys, ...rejectionKeys, ...footerKeys],
          // 店铺信息变更审核
          '4': [...headerKeys, ...shopInfoKeys, 'createdTime', ...footerKeys],
          // 店铺信息变更审核驳回（与审核保持一致 + 驳回字段）
          '5': [...headerKeys, ...shopInfoKeys, ...rejectionKeys, ...footerKeys],
          // 收款账户变更审核
          '6': [...headerKeys, ...payAccountKeys, 'createdTime', ...footerKeys],
          // 收款账户变更审核驳回（与审核保持一致 + 驳回字段）
          '7': [...headerKeys, ...payAccountKeys, ...rejectionKeys, ...footerKeys]
        };
      })(),
      tableColumns: [],
      tableData: [],
      defaultSelectValue: 1,
      toExamineList: [
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002833')},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002834')},
        {value: '3', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002835')},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002836')},
        {value: '5', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002837')},
        {value: '6', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002838')},
        {value: '7', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002839')}
      ],
      scaleList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002735')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002736')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002737')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002738')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002739')}
      ], // 经营规模
      enumData: [],
      businessAddressData: []
    };
  },
  computed: {
    labelTimerName() {
      let name = '';
      if (['1', '2', '4', '6'].includes(this.pageParams.toExamineStatus)) {
        name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002819');
      } else if (['3', '5', '7'].includes(this.pageParams.toExamineStatus)) {
        name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002840');
      }
      return name;
    },
    // 下拉输入框
    dropDownInputList() {
      if (['1', '2', '3'].includes(this.pageParams.toExamineStatus)) {
        return DROPDOWNINPUTLIST;
      } else {
        return [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002806'), parameterKey: 'ymsMerchantIds'}
        ];
      }
    },
    filterKeyList() {
      let parameterKeyList = DROPDOWNINPUTLIST.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 搜索框占位符
    placeholderName() {
      if (['1', '2', '3'].includes(this.pageParams.toExamineStatus)) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002821');
      } else if (['4', '5'].includes(this.pageParams.toExamineStatus)) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002841');
      } else if (['6', '7'].includes(this.pageParams.toExamineStatus)) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002842');
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await v.systemDefaultLanguage();
        let enumKeyList = [
          'YmsMerchantStoreManagementModelCoreEnum',
          'YmsMerchantStoreProductReleaseRateCoreEnum',
          'YmsMerchantStoreAttributeAttributeValueCoreEnum',
          'YmsPayAccountPayTypeSupplierEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        v.businessAddressData = await v.getProvinceBasicData('CN');
        v.handleColumns();
        v.search();
      })();
    },
    // 切换tab栏
    changeTab(value) {
      this.reset();
      this.handleColumns();
      switch (value) {
        // 入驻审核
        case '1':
          this.pageParams.supplierAuditStatus = 1;
          this.pageParams.updateSupplierAuditStatus = null;
          this.pageParams.updateSupplierStoreAuditStatus = null;
          this.pageParams.updateSupplierPayAccountAuditStatus = null;
          break;
        // 工商信息变更审核
        case '2':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = 1;
          this.pageParams.updateSupplierStoreAuditStatus = null;
          this.pageParams.updateSupplierPayAccountAuditStatus = null;
          break;
        // 工商信息变更审核驳回
        case '3':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = 0;
          this.pageParams.updateSupplierStoreAuditStatus = null;
          this.pageParams.updateSupplierPayAccountAuditStatus = null;
          break;
        // 店铺信息变更审核
        case '4':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = null;
          this.pageParams.updateSupplierStoreAuditStatus = 1;
          this.pageParams.updateSupplierPayAccountAuditStatus = null;
          break;
        // 店铺信息变更审核驳回
        case '5':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = null;
          this.pageParams.updateSupplierStoreAuditStatus = 0;
          this.pageParams.updateSupplierPayAccountAuditStatus = null;
          break;
        // 收款账户变更审核
        case '6':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = null;
          this.pageParams.updateSupplierStoreAuditStatus = null;
          this.pageParams.updateSupplierPayAccountAuditStatus = 1;
          break;
        // 收款账户变更审核驳回
        case '7':
          this.pageParams.supplierAuditStatus = null;
          this.pageParams.updateSupplierAuditStatus = null;
          this.pageParams.updateSupplierStoreAuditStatus = null;
          this.pageParams.updateSupplierPayAccountAuditStatus = 0;
          break;
      }
      this.$nextTick(() => {
        this.search();
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset(type) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      this.pageParams.upDown = 'up';
      const obj = {
        '1': 'createdTime',
        '2': 'updateSupplierAuditTime',
        '3': 'supplierAuditedTime',
        '4': 'updateSupplierStoreAuditTime',
        '5': 'supplierAuditedTime',
        '6': 'updateSupplierPayAccountAuditTime',
        '7': 'supplierAuditedTime'
      };
      if (obj[v.pageParams.toExamineStatus]) {
        v.pageParams.orderBy = obj[v.pageParams.toExamineStatus];
      }
      v.registerTime = [];
      v.changeInput(1);
      v.resetDate();
      if (type) {
        v.getList();
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let {toExamineStatus, ...params} = v.pageParams;
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      params.supplierRegisterStatus = v.pageParams.toExamineStatus === '1' ? 2 : 3;
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.optionBtnWidth = [];
      if (v.getPermission('ymsSupplierMerchant_queryAuditList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsSupplierMerchant_queryAuditList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let newList = response.data.datas || [];
            if (newList.length > 0) {
              newList.forEach(item => {
                const log = item.ymsPayAccounts?.[0]?.ymsPayAccountLogs?.[0];
                const newItem = {
                  ...item,
                  changeRecord: log?.changeRecord ?? null,
                  originalRecord: log?.originalRecord ?? null,
                  ...v.handleMultilingualFormFields(item, ['name']),
                  ...v.handleStoreInfoFun(item)
                };
                v.tableData.push(newItem);
              });
              v.updateTableDom('tableDom');
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置时间
    resetDate() {
      const timeParams = [
        'createdStartTime',
        'createdEndTime',
        'updateSupplierAuditStartTime',
        'updateSupplierAuditEndTime',
        'supplierAuditedStartTime',
        'supplierAuditedEndTime',
        'updateSupplierStoreAuditStartTime',
        'updateSupplierStoreAuditEndTime',
        'updateSupplierPayAccountAuditStartTime',
        'updateSupplierPayAccountAuditEndTime'
      ];
      timeParams.forEach(param => {
        this.pageParams[param] = null;
      });
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.resetDate();
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          switch (v.pageParams.toExamineStatus) {
            case '1':
              resetTimeParams(['updateSupplierAudit', 'supplierAudited', 'updateSupplierStoreAudit', 'updateSupplierPayAccountAudit']);
              setTimeParams('created', timeList);
              break;
            case '2':
              resetTimeParams(['created', 'supplierAudited', 'updateSupplierStoreAudit', 'updateSupplierPayAccountAudit']);
              setTimeParams('updateSupplierAudit', timeList);
              break;
            case '3':
              resetTimeParams(['created', 'updateSupplierAudit', 'updateSupplierStoreAudit', 'updateSupplierPayAccountAudit']);
              setTimeParams('supplierAudited', timeList);
              break;
            case '4':
              resetTimeParams(['created', 'updateSupplierAudit', 'supplierAudited', 'updateSupplierPayAccountAudit']);
              setTimeParams('updateSupplierStoreAudit', timeList);
              break;
            case '5':
              resetTimeParams(['created', 'updateSupplierAudit', 'updateSupplierStoreAudit', 'updateSupplierPayAccountAudit']);
              setTimeParams('supplierAudited', timeList);
              break;
            case '6':
              resetTimeParams(['created', 'updateSupplierAudit', 'supplierAudited', 'updateSupplierStoreAudit']);
              setTimeParams('updateSupplierPayAccountAudit', timeList);
              break;
            case '7':
              resetTimeParams(['created', 'updateSupplierAudit', 'updateSupplierStoreAudit', 'updateSupplierPayAccountAudit']);
              setTimeParams('supplierAudited', timeList);
              break;
          }

          // 设置时间参数
          function setTimeParams(prefix, timeList) {
            v.pageParams[`${prefix}StartTime`] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams[`${prefix}EndTime`] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          }

          // 重置指定前缀的时间参数
          function resetTimeParams(prefixes) {
            for (const key of prefixes) {
              v.pageParams[`${key}StartTime`] = null;
              v.pageParams[`${key}EndTime`] = null;
            }
          }
        }
      }
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 通过审核
    approvedThroughReviewBtn(ymsMerchantId, name) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002843'),
        content: `<span class="themeColor underline">${name}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002832')}`,
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002844'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          let params = {
            auditRemarks: null,
            updateYmsSupplierAscriptionWarehouseBos: [],
            ymsMerchantId: ymsMerchantId,
            supplierAuditStatus: 2, // 供应商入驻审核状态 0审核不通过、1待审核、2审核通过
          };
          v.axios.post(api.post_ymsSupplierMerchant_updateSupplierAuditInfo, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002694'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取全量列定义映射表
    allColumnDefinitions() {
      let v = this;
      return {
        ymsMerchantId: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'),
          key: 'ymsMerchantId',
          minWidth: 120,
          align: 'center'
        },
        supplierName: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'supplierName',
          minWidth: 150,
          align: 'center'
        },
        supplierStatus: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002845'),
          key: 'supplierStatus',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let text = '-';
            let auditType = params.row.auditType || null;
            let list = [
              {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002846')},
              {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002847')},
            ];
            list.map((item) => {
              if (item.value === auditType) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        currency: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000733'),
          key: 'currency',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || 'CNY';
            return h('span', currency);
          }
        },
        businessLicensePath: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002751'),
          key: 'businessLicensePath',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return v.tableImg(h, params, 'businessLicensePath',
              null, null, 'left', false, false);
          }
        },
        identificationCardPath: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002848'),
          key: 'identificationCardPath',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return v.tableImg(h, params, 'identificationCardPath',
              null, null, 'left', false, false);
          }
        },
        businessScale: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002849'),
          key: 'businessScale',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let scale = params.row.scale;
            let text = '-';
            v.scaleList.map((item) => {
              if (item.value === scale) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        contacts: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811'),
          key: 'contacts',
          minWidth: 150,
          align: 'center'
        },
        mobile: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002812'),
          key: 'mobile',
          align: 'center',
          minWidth: 140
        },
        phone: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002813'),
          key: 'phone',
          minWidth: 130,
          align: 'center'
        },
        contactName: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002850'),
          key: 'contactName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = params.row.contacts || '-';
            return h('span', text);
          }
        },
        contactPhoneNumber: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002851'),
          key: 'contactPhoneNumber',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let text = params.row.contactsPhone || '-';
            return h('span', text);
          }
        },
        fixedTelephone: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002852'),
          key: 'fixedTelephone',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let text = params.row.phone || '-';
            return h('span', text);
          }
        },
        email: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'center',
          minWidth: 170
        },
        totalSkuNumber: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002814'),
          key: 'totalSkuNumber',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let number = params.row.totalSkuNumber || 0;
            return h('span', number);
          }
        },
        shopName: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001794'),
          key: 'shopName',
          align: 'center',
          minWidth: 170,
        },
        shopLogoPath: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002853'),
          key: 'shopLogoPath',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return v.tableImg(h, params, 'shopLogoPath', null, null, 'left', false, false);
          }
        },
        managementModel: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002854'),
          key: 'managementModel',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            return h('span', params.row.managementModel || '-');
          }
        },
        plannedBusinessCategory: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002855'),
          key: 'plannedBusinessCategory',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let val = params.row.plannedBusinessCategory;
            return h('span', val && val.length > 0 ? val : '-');
          }
        },
        shelvesProductsNumber: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002856'),
          key: 'shelvesProductsNumber',
          minWidth: 150,
          align: 'center'
        },
        productReleaseNumber: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002857'),
          key: 'productReleaseNumber',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', params.row.productReleaseNumber || '-');
          }
        },
        businessAddress: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002858'),
          key: 'businessAddress',
          minWidth: 150,
          align: 'center',
        },
        address: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002859'),
          key: 'storeAddress',
          minWidth: 150,
          align: 'center'
        },

        payType: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002860'),
          key: 'payType',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let payType = params.row.payType;
            let text = payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002690') : payType === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692') : '-';
            return h('span', text);
          }
        },
        payAccountNumber: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002861'),
          key: 'payAccountNumber',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return h('span', params.row.payAccountNumber || '-');
          }
        },
        accountHolderName: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002862'),
          key: 'name',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('span', params.row.name || '-');
          }
        },
        originalRecord: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002863'),
          key: 'originalRecord',
          align: 'center',
          minWidth: 280,
          render(h, params) {
            let content = '-';
            let originalRecord = params.row.originalRecord;
            if (originalRecord) {
              let obj = JSON.parse(originalRecord);
              let payName = getEnumName(v.enumData, 'YmsPayAccountPayTypeSupplierEnum', obj.payType);
              let name = obj.payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707');
              content = [
                h('div', {style: 'textAlign: left'}, [
                  h('p', {class: 'mt5 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702') + payName),
                  h('p', {class: 'mt3 mb3'}, name + obj.payAccountNumber),
                  h('p', {class: 'mt3 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703') + obj.name)
                ])
              ];
            }
            return h('div', {class: 'flex align-items-center pl20 pr20'}, content);
          }
        },
        changeRecord: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002864'),
          key: 'changeRecord',
          align: 'center',
          minWidth: 280,
          render(h, params) {
            let content = '-';
            let changeRecord = params.row.changeRecord;
            if (changeRecord) {
              let obj = JSON.parse(changeRecord);
              let name = '';
              let payName = '';
              if (obj.payType === 1) {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705');
                payName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002690');
              } else {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707');
                payName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692');
              }
              content = [
                h('div', {style: 'textAlign: left'}, [
                  h('p', {class: 'mt5 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702') + payName),
                  h('p', {class: 'mt3 mb3'}, name + obj.payAccountNumber),
                  h('p', {class: 'mt3 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703') + obj.name)
                ])
              ];
            }
            return h('div', {class: 'flex align-items-center pl20 pr20'}, content);
          }
        },
        createdTime: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002865'),
          key: 'createdTime',
          align: 'center',
          width: 180,
          sortable: 'custom',
          sortType: 'asc',
          render(h, params) {
            let text = '-';
            let toExamineStatus = v.pageParams.toExamineStatus;
            if (['1'].includes(toExamineStatus)) {
              text = v.$uDate.dealTime(params.row.createdTime, 'fulltime') || '-';
            } else if (['2', '4', '6'].includes(toExamineStatus)) {
              let detail = params.row.ymsSupplierMerchantDetail;
              if (detail) {
                let obj = {
                  '2': 'updateSupplierAuditTime',
                  '4': 'updateSupplierStoreAuditTime',
                  '6': 'updateSupplierPayAccountAuditTime'
                }
                text = v.$uDate.dealTime(detail[obj[toExamineStatus]], 'fulltime') || '-';
              }
            }
            return h('span', text);
          }
        },
        supplierAuditedTime: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002866'),
          key: 'supplierAuditedTime',
          align: 'center',
          width: 180,
          sortable: 'custom',
          sortType: 'asc',
          render(h, params) {
            let supplierAuditedTime = params.row.supplierAuditedTime || '-';
            return h('span', supplierAuditedTime ? v.$uDate.dealTime(supplierAuditedTime, 'fulltime') : '-');
          }
        },
        reasonForRejection: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000603'),
          key: 'reasonForRejection',
          width: 250,
          align: 'center',
          render(h, params) {
            let auditRemarks = '';
            let changeRecord = params.row.changeRecord;
            if (changeRecord) {
              let obj = JSON.parse(changeRecord);
              auditRemarks = obj.updateSupplierPayAccountAuditRemark;
            }
            let text = v.pageParams.toExamineStatus === '7' ? auditRemarks : params.row.auditRemarks;
            return v.checkContentOverflow(h, text, 250, 2);
          }
        },
        options: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 200,
          align: 'center',
          fixed: 'right',
          render(h, params) {
            let ymsMerchantId = params.row.ymsMerchantId;
            let name = params.row.name_CN;
            let auditType = params.row.auditType;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002867'),
                    show: ['1', '2', '4', '6'].includes(v.pageParams.toExamineStatus) &&
                      v.getPermission('ymsSupplierMerchant_updateSupplierAuditInfo'),
                    clickFn: () => {
                      if (['1', '2'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['addSupplier'].initSupplierData('audit', params.row, v.pageParams.toExamineStatus);
                      } else if (v.pageParams.toExamineStatus === '4') {
                        v.$refs['storeInfoReview'].initStoreInfoReviewData('audit', params.row);
                      } else if (v.pageParams.toExamineStatus === '6') {
                        v.$refs['collectionAccountReview'].initCollectionAccountReviewData('audit', params.row);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      if (['1', '2', '3'].includes(v.pageParams.toExamineStatus)) {
                        let tabType = ['2', '3'].includes(v.pageParams.toExamineStatus) ? '2' : '1';
                        v.$refs['addSupplier'].initSupplierData('look', params.row, tabType);
                      } else if (['4', '5'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['storeInfoReview'].initStoreInfoReviewData('look', params.row);
                      } else if (['6', '7'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['collectionAccountReview'].initCollectionAccountReviewData('look', params.row);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsSupplierMerchant_update'),
                    clickFn: () => {
                      if (['1', '2', '3'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['addSupplier'].initSupplierData('edit', params.row, v.pageParams.toExamineStatus);
                      } else if (['4', '5'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['storeInfoReview'].initStoreInfoReviewData('edit', params.row);
                      } else if (['6', '7'].includes(v.pageParams.toExamineStatus)) {
                        v.$refs['collectionAccountReview'].initCollectionAccountReviewData('edit', params.row);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002843'),
                    show: v.pageParams.toExamineStatus === '3' && auditType === 1 && v.getPermission('ymsSupplierMerchant_update'),
                    clickFn: () => {
                      v.approvedThroughReviewBtn(ymsMerchantId, name);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsMerchantId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      };
    },
    // 处理列表Columns字段
    handleColumns() {
      this.tableColumns = [];
      let visibleKeys = this.columnKeyGroups[this.pageParams.toExamineStatus];
      if (!visibleKeys) {
        this.$forceUpdate();
        return;
      }
      let allColumns = this.allColumnDefinitions();
      // 构建多语言名称列
      let multilingualCols = [];
      if (this.multilingualNamesList.length > 0) {
        this.multilingualNamesList.map((item) => {
          let key = 'name_' + item.code;
          multilingualCols.push({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
            key: key,
            align: 'center',
            minWidth: 150
          });
        });
      }
      // 按key列表顺序组装列
      let columns = [];
      visibleKeys.forEach((key) => {
        if (key === 'supplierName' && multilingualCols.length > 0) {
          columns.push(...multilingualCols);
        } else if (allColumns[key]) {
          columns.push(allColumns[key]);
        }
      });
      this.tableColumns = columns;
      this.$forceUpdate();
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      let orderByMap = {
        '2': 'updateSupplierAuditTime',
        '3': 'updateSupplierAuditTime',
        '4': 'updateSupplierStoreAuditTime',
        '5': 'updateSupplierStoreAuditTime',
        '6': 'updateSupplierPayAccountAuditTime',
        '7': 'updateSupplierPayAccountAuditTime'
      };
      this.pageParams.orderBy = orderByMap[this.pageParams.toExamineStatus] || data.key;
      this.pageParamsStatus = true;
    },
    // 处理店铺信息
    handleStoreInfoFun(items) {
      let stores = {};
      let groundingList = [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002740')},
        {value: 2, name: '10~30'},
        {value: 3, name: '30~50'},
        {value: 4, name: '50~100'},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002741')}
      ];
      let ymsMerchantStores = items.ymsMerchantStores || [];
      if (ymsMerchantStores.length > 0) {
        let obj = ymsMerchantStores[0];
        let productReleaseRateName = getEnumName(this.enumData, 'YmsMerchantStoreProductReleaseRateCoreEnum', obj.productReleaseRate);
        let productReleaseName = productReleaseRateName + obj.productReleaseNumber + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002749');
        let ymsMerchantStoreAddresses = obj.ymsMerchantStoreAddresses || [];
        let ymsMerchantStoreAttributes = obj.ymsMerchantStoreAttributes || [];
        let plannedBusinessCategoryList = getEnumList(this.enumData, 'YmsMerchantStoreAttributeAttributeValueCoreEnum', 'number');
        let categoryList = [];
        if (ymsMerchantStoreAttributes.length > 0) {
          ymsMerchantStoreAttributes.map((item) => {
            plannedBusinessCategoryList.map((ele) => {
              if (ele.value === item.attributeValue) {
                categoryList.push(ele.name);
              }
            });
          });
        }
        stores = {
          ...obj,
          shopName: obj.name,
          managementModel: getEnumName(this.enumData, 'YmsMerchantStoreManagementModelCoreEnum', obj.managementModel),
          productReleaseNumber: productReleaseRateName !== aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002750') ? productReleaseName : productReleaseRateName,
          plannedBusinessCategory: categoryList.join('、'),
          shelvesProductsNumber: groundingList.find((item) => item.value === obj.shelvesProductsNumber)?.name
        };
        if (ymsMerchantStoreAddresses.length > 0) {
          let addressesInfo = ymsMerchantStoreAddresses[0];
          stores.businessAddress = this.handleAddressName(addressesInfo, this.businessAddressData);
          stores.storeAddress = obj.address ? obj.address : addressesInfo.street;
        }
      }
      return stores;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    addSupplierModal,
    commonLogModal,
    dropDownFilter,
    storeInfoReviewModal,
    collectionAccountReviewModal
  }
};
</script>

<style lang="less">

</style>